import SecondaryTopbar from "components/SecondaryTopbar";

const UserTopbar = ({ menu, findActiveCallback }) => {
  return (
    <SecondaryTopbar menu={menu} findActiveCallback={findActiveCallback} />
  );
};

export default UserTopbar;
